const Perfil = {
  Administrador: "Administrador",
  'Contas a Receber': 'Contas a Receber',
  'Funcionário': 'Funcionário',
  'CDL': 'CDL'
}

export default Perfil;
